import { createSelector } from 'reselect'
import firstBy from 'thenby'

const _alphabeticalSubjects = state => {
  return state.subjects.items.sort(firstBy('name'))
}

export const alphabeticalSubjects = createSelector(
  [_alphabeticalSubjects],
  subjects => {
    return subjects
  }
)



// WEBPACK FOOTER //
// ./src/selectors/subjects.js